import { waitForAnimations } from "../utils/animation.js";
import type {
  AnimationHelperAwaiter,
  AnimatedElementValue,
} from "./useDomAnimationHelper.types.js";

/**
 *
 *
 *
 */
export const normalizeElements = (elementOrElements: AnimatedElementValue): Element[] => {
  if (!elementOrElements) return [];
  return "ELEMENT_NODE" in elementOrElements
    ? [elementOrElements]
    : Array.from(elementOrElements).filter(Boolean);
};

/**
 *
 *
 *
 *
 */
export const onAnimationFrame: () => AnimationHelperAwaiter = () => (callback) => {
  /*                                       */
  const id = requestAnimationFrame(callback);
  return () => cancelAnimationFrame(id);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const onElementAnimated: (
  getAnimatedElements: () => AnimatedElementValue,
  getAnimationsOptions?: Parameters<HTMLElement["getAnimations"]>[0],
) => AnimationHelperAwaiter = (getAnimatedElements, getAnimationsOptions) => (callback) => {
  /*                       */
  const elements = normalizeElements(getAnimatedElements());
  /*                                               */
  waitForAnimations(elements, getAnimationsOptions).then(callback);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const onTimeout: (timeout: number) => AnimationHelperAwaiter = (timeout) => (callback) => {
  const id = setTimeout(callback, timeout);
  return () => clearTimeout(id);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const OnImmediate: AnimationHelperAwaiter = (callback) => callback();

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const OnAnimationFrame: AnimationHelperAwaiter = onAnimationFrame();
